import script from "./DescriptionField.vue?vue&type=script&setup=true&lang=js"
export * from "./DescriptionField.vue?vue&type=script&setup=true&lang=js"

import "./DescriptionField.vue?vue&type=style&index=0&id=17f0db90&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17f0db90"]])

export default __exports__